// Cấu hình phân quyền theo menu: Nhóm menu → Chức năng → Hành động.
// Mỗi (path + action) tương ứng 1 bản ghi Permission ở backend.
// Thêm menu/chức năng mới: khai báo ở đây rồi bấm "Import routes" ở trang Vai trò.

export type PermissionAction =
  | "VIEW"
  | "CREATE"
  | "UPDATE"
  | "DELETE"
  | "EXPORT"
  | "SEND_EMAIL"
  | "BLOCK"
  | "RESET_PASSWORD"
  | "ONLY_MINE"
  | "APPROVE"
  | "UPDATE_DEBT"
  | "UNLOCK";

// Thứ tự cột hiển thị trong bảng phân quyền
export const PERMISSION_ACTIONS: { key: PermissionAction; title: string }[] = [
  { key: "VIEW", title: "Xem" },
  { key: "CREATE", title: "Thêm" },
  { key: "UPDATE", title: "Sửa" },
  { key: "UPDATE_DEBT", title: "Cập nhật công nợ" },
  { key: "APPROVE", title: "Duyệt báo giá" },
  { key: "UNLOCK", title: "Mở khoá" },
  { key: "DELETE", title: "Xoá" },
  { key: "BLOCK", title: "Khoá/Mở" },
  { key: "RESET_PASSWORD", title: "Reset mật khẩu" },
  { key: "ONLY_MINE", title: "Chỉ mình tôi" },
  { key: "EXPORT", title: "Xuất Excel" },
  { key: "SEND_EMAIL", title: "Gửi Email" },
];

export interface PermissionFeature {
  path: string; // trùng path của route (dùng cho quyền Xem / vào menu)
  title: string;
  actions: PermissionAction[];
}

export interface PermissionGroup {
  key: string;
  menuName: string;
  title: string;
  features: PermissionFeature[];
}

export const permissionMenu: PermissionGroup[] = [
  {
    key: "lead",
    title: "Quản lý lead",
    menuName: "lead",
    features: [
      {
        path: "/lead",
        title: "Danh sách lead (Menu)",
        actions: ["VIEW", "CREATE", "UPDATE", "DELETE"],
      },
    ],
  },
  {
    key: "customer",
    title: "Quản lý khách hàng",
    menuName: "customer",
    features: [
      {
        path: "/customer",
        title: "Danh sách khách hàng (Menu)",
        actions: ["VIEW", "CREATE", "UPDATE", "DELETE", "ONLY_MINE"],
      },
    ],
  },
  {
    key: "opportunity",
    title: "Quản lý cơ hội",
    menuName: "opportunity",
    features: [
      {
        path: "/opportunity",
        title: "Danh sách cơ hội (Menu)",
        actions: ["VIEW", "CREATE", "UPDATE", "DELETE", "APPROVE"],
      },
    ],
  },
  {
    key: "quote",
    title: "Quản lý báo giá",
    menuName: "quote",
    features: [
      {
        path: "/quote",
        title: "Danh sách báo giá (Menu)",
        actions: ["VIEW", "UPDATE", "APPROVE"],
      },
    ],
  },
  {
    key: "order",
    title: "Quản lý đơn hàng",
    menuName: "order",
    features: [
      {
        path: "/order",
        title: "Danh sách đơn hàng (Menu)",
        actions: ["VIEW", "UPDATE", "DELETE", "UPDATE_DEBT"],
      },
    ],
  },
  {
    key: "feedback",
    title: "Quản lý phản hồi",
    menuName: "feedback",
    features: [
      {
        path: "/feedback",
        title: "Danh sách phản hồi (Menu)",
        actions: ["VIEW", "CREATE", "UPDATE", "DELETE"],
      },
    ],
  },
  {
    key: "todo",
    title: "Quản lý việc cần làm",
    menuName: "todo",
    features: [
      {
        path: "/todo",
        title: "Danh sách việc cần làm (Menu)",
        actions: ["VIEW", "CREATE", "UPDATE", "DELETE", "ONLY_MINE"],
      },
    ],
  },
  {
    key: "staff",
    title: "Quản lý nhân viên",
    menuName: "staff",
    features: [
      {
        path: "/staff",
        title: "Danh sách nhân viên (Menu)",
        actions: ["VIEW", "CREATE", "UPDATE", "DELETE", "BLOCK", "RESET_PASSWORD"],
      },
    ],
  },
  {
    key: "role",
    title: "Quản lý vai trò",
    menuName: "role",
    features: [
      {
        path: "/role",
        title: "Danh sách vai trò (Menu)",
        actions: ["VIEW", "CREATE", "UPDATE", "DELETE"],
      },
    ],
  },
  {
    key: "commission",
    title: "Hoa hồng SALE",
    menuName: "commission",
    features: [
      {
        path: "/commission",
        title: "Hoa hồng SALE (Menu)",
        actions: ["VIEW", "CREATE", "UNLOCK", "ONLY_MINE"],
      },
    ],
  },
  {
    key: "log",
    title: "Quản lý log",
    menuName: "log",
    features: [
      {
        path: "/log",
        title: "Danh sách log (Menu)",
        actions: ["VIEW"],
      },
    ],
  },
  {
    key: "configuration",
    title: "Quản lý cấu hình",
    menuName: "configuration",
    features: [
      {
        path: "/configuration",
        title: "Danh sách cấu hình (Menu)",
        actions: ["VIEW", "UPDATE"],
      },
    ],
  },
];

export const permissionKey = (path: string, action: string) => `${path}|${action}`;

// Toàn bộ (path, action) khai báo trong cấu hình
export const allPermissionItems = () =>
  permissionMenu.flatMap((group) =>
    group.features.flatMap((feature) =>
      feature.actions.map((action) => ({
        path: feature.path,
        action,
        title: feature.title,
      })),
    ),
  );
